export const CustomReactSelectStyles = (isDarkMode: boolean) => ({
  control: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: state.isDisabled
      ? isDarkMode
        ? '#1f2327'
        : '#f5f5f5'
      : isDarkMode
        ? '#262A2F'
        : '#fff',

    borderColor: state.isDisabled
      ? '#ccc'
      : state.isFocused
        ? isDarkMode
          ? '#fff'
          : '#b0c4de'
        : isDarkMode
          ? '#262A2F'
          : '#ddd',

    cursor: state.isDisabled ? 'not-allowed' : 'default',
    opacity: state.isDisabled ? 0.6 : 1,

    boxShadow: state.isDisabled
      ? 'none'
      : state.isFocused
        ? isDarkMode
          ? '0 0 5px rgba(255, 255, 255, 0.5)'
          : '0 0 5px rgba(0, 0, 255, 0.2)'
        : styles.boxShadow,

    '&:hover': {
      borderColor: state.isDisabled ? '#ccc' : isDarkMode ? '#fff' : '#b0c4de',
      boxShadow: state.isDisabled
        ? 'none'
        : isDarkMode
          ? '0 0 5px rgba(255, 255, 255, 0.5)'
          : '0 0 5px rgba(0, 0, 255, 0.2)',
    },

    outline: 'none',
  }),
  placeholder: (styles: any) => ({
    ...styles,
    color: '#878A99', // Customize placeholder color
  }),
  singleValue: (styles: any, state: any) => ({
    ...styles,
    color: state.isDisabled ? '#303030' : isDarkMode ? '#fff' : '#333',
  }),
  option: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: state.isSelected
      ? isDarkMode
        ? '#4bb189'
        : '#4bb189'
      : state.isFocused
        ? isDarkMode
          ? '#4bb18980'
          : '#4bb18980'
        : 'transparent',
    color: state.isSelected ? '#fff' : isDarkMode ? '#ffffff' : '#000000',
    padding: 10,
    ':hover': {
      backgroundColor: isDarkMode ? '#4bb189' : '#4bb189',
      color: '#fff',
    },
  }),
});
